import { Component } from "@angular/core";
import { BaseComponent, IDatatableStateSaveableComponent } from "@impacgroup/angular-baselib";

@Component({
    selector: "app-interestedparties-main",
    templateUrl: "./interestedparties.main.component.html",
    standalone: false
})
export class InterestedPartiesMainComponent extends BaseComponent implements IDatatableStateSaveableComponent {
    public listStateData: any;
}
